import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import {
  Budget,
  BudgetSummaryApiResponse,
  Cliente
} from "@interfaces/budget-response";
import { BudgetsQuery } from "@interfaces/budgets-query";
import { BudgetItems } from "@interfaces/construction";
import { Store } from "@ngrx/store";
import { selectToken } from "@state/selectors/user.selectors";
import { HttpService } from "./http.service";

@Injectable({
  providedIn: "root"
})
export class MvService {
  url = `${environment.api.mv.obra}`;
  token = this.store.selectSignal(selectToken);

  constructor(
    private readonly httpService: HttpService,
    private readonly store: Store
  ) {}

  public fetchBudgets(query: BudgetsQuery) {
    const params = new URLSearchParams({
      page: query.paginacao.toString(),
      limit: query.pageSize.toString()
    });

    if (query.pesquisa?.trim()) {
      params.set("pesquisa", query.pesquisa.trim());
    }

    return this.httpService.get<BudgetSummaryApiResponse>(
      `${this.url}/obra/nf-server/getOrcamentosPaginado?${params.toString()}`,
      new HttpHeaders({
        Authorization: `Bearer ${this.token()}`
      })
    );
  }

  public fetchObra(id: number) {
    return this.httpService.get<BudgetItems>(
      `${this.url}/obra/getListaItensObraResumoNf/${id}`,
      new HttpHeaders({
        Authorization: `Bearer ${this.token()}`
      })
    );
  }

  public fetchBudget(id: number) {
    return this.httpService.get<Budget>(
      `${this.url}/obra/getResumoByIdNf/${id}`,
      new HttpHeaders({
        Authorization: `Bearer ${this.token()}`
      })
    );
  }

  public saveClient(client: Partial<Cliente>) {
    return this.httpService.post<Cliente>(
      `${this.url}/cliente/salvarNf`,
      {
        form: client,
        telefoneDelete: [],
        emailDelete: []
      },
      new HttpHeaders({
        Authorization: `Bearer ${this.token()}`
      })
    );
  }
}
